import { getOrgTypes } from 'app/dataProviders/orgTypes'

let orgTypesAbortController: AbortController | undefined
export const getFilterOrgTypes = async () => {
  orgTypesAbortController?.abort()
  orgTypesAbortController = new AbortController()
  const orgTypes = await getOrgTypes(orgTypesAbortController?.signal)
  if (orgTypes) {
    return orgTypes.map(({ ID, title }) => ({
      id: ID,
      title,
    }))
  }
  return []
}
